import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DictionaryPositionType} from '../modules/admin/components/dictionary/position/dictionary-position-type';
import {Position} from '../modules/admin/components/dictionary/position/dictionary-position';

@Injectable()
export class CenterPositionService {

  constructor(private http: HttpClient) {
  }

  get(id: number) {
    return this.http.get<Position>('api/a/dictionary/position/' + id);
  }

  getAll() {
    return this.http.get<any[]>('api/a/dictionary/position/getAll');
  }

  getByType(typeID: number) {
    if (!typeID) {
      typeID = 0;
    }
    return this.http.get<Position[]>('api/s/dictionary/position/getByType/' + typeID);
  }

  save(position: Position) {
    return this.http.post<any>('api/a/dictionary/position/save', position);
  }

  deleteById(id: number) {
    return this.http.delete<any>('api/a/dictionary/position/delete/' + id);
  }

  getTypes() {
    return this.http.get<DictionaryPositionType[]>('api/s/dictionary/position/types');
  }

  getTypesByUser() {
    return this.http.get<DictionaryPositionType[]>('api/a/dictionary/position/types/getByUser');
  }
}



// WEBPACK FOOTER //
// ./src/app/common_services/dictionary-position.service.ts